import type { PaginationProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';

import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

const COLORS = [
  'primary',
  'secondary',
  'info',
  'success',
  'warning',
  'error',
] as const;

// NEW VARIANT
declare module '@mui/material/Pagination' {
  interface PaginationPropsColorOverrides {
    error: true;
    info: true;
    success: true;
    warning: true;
  }

  interface PaginationPropsVariantOverrides {
    soft: true;
  }
}

const Pagination = (theme: Theme) => {
  const isLight = theme.palette.mode === 'light';

  const rootStyle = (ownerState: PaginationProps) => {
    const outlinedVariant = ownerState.variant === 'outlined';

    const softVariant = ownerState.variant === 'soft';

    const defaultStyle = {
      '& .MuiPaginationItem-root': {
        ...(outlinedVariant && {
          borderColor: alpha(theme.palette.grey[500], 0.32),
        }),
        '&.Mui-selected': {
          fontWeight: theme.typography.fontWeightMedium,
        },
      },
    };

    const colorStyle = COLORS.map((color) => ({
      ...(ownerState.color === color && {
        ...(softVariant && {
          '& .MuiPaginationItem-root': {
            '&.Mui-selected': {
              '&:hover': {
                backgroundColor: alpha(theme.palette[color].main, 0.32),
              },
              backgroundColor: alpha(theme.palette[color].main, 0.16),
              color: theme.palette[color][isLight ? 'dark' : 'light'],
            },
          },
        }),
      }),
    }));

    return [...colorStyle, defaultStyle];
  };

  return {
    MuiPagination: {
      defaultProps: {
        color: 'primary',
      },

      styleOverrides: {
        root: ({ ownerState }: { ownerState: PaginationProps }) =>
          rootStyle(ownerState),
      },
    },
  };
};

export default Pagination;
